var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchiements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1412 6.85704L17.9983 11.9999L11.9983 3.42847L5.99833 11.9999L0.855469 6.85704V17.9999C0.855469 18.6818 1.12639 19.336 1.60862 19.8182C2.09085 20.3005 2.74492 20.5713 3.4269 20.5713H20.5698C21.2517 20.5713 21.9059 20.3005 22.3881 19.8182C22.8703 19.336 23.1412 18.6818 23.1412 17.9999V6.85704Z",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchiements);
export default __webpack_public_path__ + "static/media/achiements.51dfe96485da331511de612259b6117a.svg";
export { ForwardRef as ReactComponent };